// extracted by mini-css-extract-plugin
export default {"skeletonBlock":"ProjectSliderSkeleton_skeletonBlock__JGmLD","skeleton":"ProjectSliderSkeleton_skeleton__ybzWm"};